import dayjs from "dayjs";
import { checkSnils, checkEmail, checkEAN13, adjustLAT } from "./utils";

export const isRequired = (value: any) => value && value.toString() ? false : 'Необходимо заполнить поле';

export const isSnils = (value: any) => checkSnils(value) ? false : 'Не верный СНИЛС';

export const isEmail = (value: string) => !value || checkEmail(value) ? false : 'Введите корректный адрес электронной почты';

export const isRus = (value: string) => !value || /^[а-яёА-ЯЁ\- ]+$/.test(value) ? false : 'Можно использовать только символы русского алфавита';

export const isNumber = (value: string) => !value || /^[0-9-]+$/.test(value) ? false : 'Можно использовать только цифры и дефис';

export const isYear = (value: number) => value >= 1900 && value <= 2100 ? false : 'Укажите правильный год';

export const isCorrectDate = (value: any) => !value || (dayjs(value).year() >= 1900 && dayjs().isAfter(value)) ? false : 'Введите корректную дату';

export const isCorrectGLN = (value: string) => !value || checkEAN13(value) ? false : 'Введите корректный GLN';
export const isCorrectPercent = (value: number) => value >= 100 && value <= 0 ? false : 'Значение не может быть больше 100% и 0%';

export const isPassportRB = (value: string) => {
	if (!value) return false;
	const normalized = adjustLAT(String(value).replace(/\s+/g, ''));
	return /^[A-Z]{2}[0-9]{7}$/.test(normalized) ? false : 'Паспорт РБ: 2 латинские буквы и 7 цифр (например MC3692439)';
};

export const INP_PATTERN = /^[0-9]{7}[A-Z][0-9]{3}[A-Z]{2}[0-9]$/;

export const normalizeInp = (value: string) =>
	String(value || '').replace(/\s+/g, '').toUpperCase();

export const isInp = (value: string) => {
	if (!value || value === '-') return false;
	return INP_PATTERN.test(normalizeInp(value))
		? false
		: 'Идентификационный номер: 7 цифр, буква, 3 цифры, 2 буквы, цифра (например 4080469B061PB7)';
};

export const isStreetGeoCode = (value: string) => {
	if (!value) return false;
	return /^\d{10,32}$/.test(String(value).trim()) ? false : 'Код НСИ ЦИСЗ: числовой код StreetGeoRegistry (10–32 цифр)';
};
